import { Component, Input, OnChanges } from '@angular/core';
import moment from 'moment';
import { kpiData } from '../../../model/performance.model';
import { Months } from '../../../services/performance-constants.service';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-kpi',
  templateUrl: './kpi.component.html',
  styleUrls: ['./kpi.component.css']
})
export class KPIComponent implements OnChanges {
  @Input() kpiData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  @Input() isRefresh : any;
  clonedKPI: { [s: string]: kpiData } = {};
  excludeRows:string[]=[];
  hideRows:string[]=[];
  kpiDataFinal:kpiData[] = [];
  currentYear:number;
  officeCount: number;
  fieldCount: number;
  contractorCount: number;
  KPIData1 : any;
  DisableExport : boolean = false;
  constructor(private PDService: PerformanceService,private router: Router) {
    this.excludeRows = ["Total management Visit", "Closed management Visit", "Staff Observation", "Contractor Observation"];
    this.hideRows = ["Closed management Visit", "Contractor Observation"];
  }
  ngOnChanges(){

    this.kpiDataFinal = [];
    if(this.kpiData && this.kpiData.length > 0 && this.kpiData[0].ComponentName){
      this.kpiDataFinal = this.kpiData;
      this.currentYear = this.kpiData.year

      this.officeCount = this.kpiDataFinal.find(s=> s.ComponentName === 'Safety Observation - Office Staff') ? +this.kpiDataFinal.find(s=> s.ComponentName === 'Safety Observation - Office Staff').Jan.split(',')[1] : 0;
      this.fieldCount = this.kpiDataFinal.find(s=> s.ComponentName === 'Safety Observation - Field Staff') ? +this.kpiDataFinal.find(s=> s.ComponentName === 'Safety Observation - Field Staff').Jan.split(',')[1] : 0;
      this.contractorCount = this.kpiDataFinal.find(s=> s.ComponentName === 'Safety Observation - Contractor Crew') ? +this.kpiDataFinal.find(s=> s.ComponentName === 'Safety Observation - Contractor Crew').Jan.split(',')[1] : 0;
      if(this.isRefresh ==1)
      {
      this.calculateData();
      }
    }
  }

  onRowEditInit(kpi: kpiData) {
    this.clonedKPI[kpi.Id] = { ...kpi };
    this.DisableExport = true;
  }

  onRowEditSave(kpi: kpiData) {
    if (kpi.Id > 0) {
      delete this.clonedKPI[kpi.Id];
      //this.messageService.add({severity:'success', summary: 'Success', detail:'Product is updated'});
    } else {
      //this.messageService.add({severity:'error', summary: 'Error', detail:'Invalid Price'});
    }
    this.calculateData();
    this.DisableExport = Object.keys(this.clonedKPI).length > 0 ? true : false;
  }

  onRowEditCancel(kpi: kpiData, index: number) {
    this.kpiDataFinal[index] = this.clonedKPI[kpi.Id];
    delete this.clonedKPI[kpi.Id];
    this.DisableExport = Object.keys(this.clonedKPI).length > 0 ? true : false;
  }

  upperchange(value,ri,month,splitChar){
    this.kpiDataFinal[ri][month] =  value + splitChar + this.kpiDataFinal[ri][month].split(splitChar)[1];
  }
  lowerchange(value,ri,month,splitChar){
    this.kpiDataFinal[ri][month] =  this.kpiDataFinal[ri][month].split(splitChar)[0] + splitChar + value;
  }

  calculateData(){
    const currentMonth = moment(new Date()).format("MMM");
      this.kpiDataFinal.forEach(element => {
        switch (element.ComponentName) {
          case 'Total management Visit':
            element.CurrentResult = ((+element[currentMonth].split('/')[0]/+element[currentMonth].split('/')[1])*100).toString().replace("NaN","0")+"%";
            element.CurrentWFTraficLight = +((+element.CurrentResult.replace(/[^\w\s]/gi, "")/+element.CurrentTarget.replace(/[^\w\s]/gi, "") * +element.WeightingFactor.replace(/[^\w\s]/gi, ""))).toFixed(2) > +element.WeightingFactor.replace(/[^\w\s]/gi, "") ? element.WeightingFactor :
            ((+element.CurrentResult.replace(/[^\w\s]/gi, "")/+element.CurrentTarget.replace(/[^\w\s]/gi, "") * +element.WeightingFactor.replace(/[^\w\s]/gi, ""))).toFixed(2).toString().replace("NaN","0")+"%";
            break;
          case 'Safety Observation - Office Staff':
            for(let i=1 ;i<13;i++){
              //element[Months[i]] = +element[Months[i]].split(',')[0] + ',' + ( element.CurrentTarget.includes('%') ? (this.officeCount * (+element.CurrentTarget.replace('%','')/100)) : this.officeCount * +element.CurrentTarget.replace('%',''));
              element[Months[i]] = +element[Months[i]].split(',')[0] + ',' + (this.officeCount * +element.CurrentTarget.replace('%',''));
            }
            element.CurrentResult = ((+element[currentMonth].split(',')[0]/+element[currentMonth].split(',')[1])*100).toFixed(2).toString().replace("NaN","0")+"%";
            element.CurrentWFTraficLight = ((+element[currentMonth].split(',')[0]/+element[currentMonth].split(',')[1]) * +element.WeightingFactor.replace(/[^\w\s]/gi, "")).toFixed(2).toString().replace("NaN","0")+"%";
            break;
          case 'Safety Observation - Field Staff':
            for(let i=1 ;i<13;i++){
              element[Months[i]] = +element[Months[i]].split(',')[0] + ',' + (this.fieldCount * +element.CurrentTarget.replace('%',''));
            }
            element.CurrentResult = ((+element[currentMonth].split(',')[0]/+element[currentMonth].split(',')[1])*100).toFixed(2).toString().replace("NaN","0")+"%";
            element.CurrentWFTraficLight = ((+element[currentMonth].split(',')[0]/+element[currentMonth].split(',')[1]) * +element.WeightingFactor.replace(/[^\w\s]/gi, "")).toFixed(2).toString().replace("NaN","0")+"%";
            break;
          case 'Safety Observation - Contractor Crew':
            for(let i=1 ;i<13;i++){
              element[Months[i]] = +element[Months[i]].split(',')[0] + ',' + (this.contractorCount * +element.CurrentTarget.replace('%',''));
            }
            element.CurrentResult = ((+element[currentMonth].split(',')[0]/+element[currentMonth].split(',')[1])*100).toFixed(2).toString().replace("NaN","0")+"%";
            element.CurrentWFTraficLight = ((+element[currentMonth].split(',')[0]/+element[currentMonth].split(',')[1]) * +element.WeightingFactor.replace(/[^\w\s]/gi, "")).toFixed(2).toString().replace("NaN","0")+"%";
            break;
          case 'Lost Time Injury Frequency (LTIF)':
          case 'Total Recordable Cases Frequency (TRCF)':
            element.CurrentResult = element[currentMonth];
            element.CurrentWFTraficLight = +element.CurrentTarget < +element.CurrentResult ? "0%": element.WeightingFactor;
            break;
          case 'Compliance to overall Actions Closed':
              element.CurrentResult = element[currentMonth]+"%";
              element.CurrentWFTraficLight =
              ((+element.CurrentResult.replace(/[^\w\s]/gi, "")/+element.CurrentTarget.replace(/[^\w\s]/gi, "")) * +element.WeightingFactor.replace(/[^\w\s]/gi, "")) > +element.WeightingFactor.replace(/[^\w\s]/gi, "") ? element.WeightingFactor :
              ((+element.CurrentResult.replace(/[^\w\s]/gi, "")/+element.CurrentTarget.replace(/[^\w\s]/gi, "")) * +element.WeightingFactor.replace(/[^\w\s]/gi, "")).toFixed(2).toString().replace("NaN","0")+"%";
              break;
          case 'RAM 4 and 5 Incidents (HiPo)':
          case 'Tier 1 & 2 incidents':
            element.CurrentResult = element[currentMonth];
            element.CurrentWFTraficLight =
            (+element.CurrentTarget.replace(/[^\w\s]/gi, "")) < (+element.CurrentResult.replace(/[^\w\s]/gi, "")) ? "0%" :
            ((+element.CurrentResult.replace(/[^\w\s]/gi, "")/+element.CurrentTarget.replace(/[^\w\s]/gi, "")) * +element.WeightingFactor.replace(/[^\w\s]/gi, "")).toFixed(2).toString().replace("NaN","0")+"%";
            break;
          default:
            break;
        }
      });
  }

  GetKPISelectedDetails(UnitId,Unit,Column,sequence){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName": "KPI" ,
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit,
        "Index":sequence
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetKPISelectedDetails.bind(this));
  }
  callbackMethodForGetKPISelectedDetails(response){
    if(response.Success)
    this.KPIData1 = response.Result;
  }

  Redirect(value,UnitId)
  {
    window.open(ConstantsService.URL.APP + ['/incident/report-incident/'+value], '_self');
  //this.router.navigate(['/incident/report-incident/'+value])
  }
  Redirect1(value,UnitId)
  {
    window.open(ConstantsService.URL.APP + ['/observation/make-observation/'+value+';unitId='+UnitId], '_self');
  // this.router.navigate(['/observation/make-observation/', value, { unitId:UnitId }])
  }
  Redirect2(value,processId)
  {
    window.open(ConstantsService.URL.APP + ['/actiontracker/all-action-details/'+value+';processId='+processId], '_self');
  // this.router.navigate(['/actiontracker/all-action-details', value, { processId:processId }])
  }
  Redirect3(value,processId)
  {
    window.open(ConstantsService.URL.APP + ['/task/create-task/'+value], '_self');
  //this.router.navigate(['/task/create-task/'+value])
  }

  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('KPITableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
  ws['!ref'] = ws['!ref'].replace('W','V');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "KPI.xlsx");

  }
  //EOC Pritesh

}
